import {TeamProgressProvider} from "@/contexts/TeamProgressContext";
import {FC} from "react";
import {AdminTeamProgressPage} from "./AdminTeamProgressPage";

export const AdminTeamProgressPagreWrapper: FC = () => (
	<TeamProgressProvider>
		<AdminTeamProgressPage />
	</TeamProgressProvider>
);
